
import "/data/action/_work/croco-manage-front/croco-manage-front/src/components/XtermSseTerminal/index.module.less?modules";
export default {"terminalContainer": `terminalContainer-upKaQmi0`}
